function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AvatarContainer from './AvatarContainer';
import AvatarInitials from './AvatarInitials';
import Image from '../Image/Image';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import getInitials from './utils/getInitilas';
import getInitialsFontSize from './utils/getInitialsFontSize';
import getSize from './utils/getSize';
import getFontWeight from './utils/getFontWeight';
import getIconSize from './utils/getIconSize';

class Avatar extends PureComponent {
  constructor(_props, context) {
    super(_props, context);

    _defineProperty(this, "handleError", () => {
      this.setState({
        imgFailedLoading: true
      });
    });

    _defineProperty(this, "renderIcon", (props, iconSize) => {
      const {
        iconName,
        iconFill,
        iconStroke,
        iconStrokeWidth,
        iconStrokeLinecap,
        iconStrokeLinejoin,
        iconColor
      } = props;

      if (iconName) {
        return React.createElement(Icon, {
          color: iconColor,
          fill: iconFill,
          iconSize: iconSize,
          name: iconName,
          stroke: iconStroke,
          strokeWidth: iconStrokeWidth,
          strokeLinecap: iconStrokeLinecap,
          strokeLinejoin: iconStrokeLinejoin
        });
      }

      return React.createElement(Icon, {
        name: "user",
        strokeLinecap: "none",
        fill: "gray.2",
        color: "gray.2",
        iconSize: iconSize
      });
    });

    this.state = {
      imgFailedLoading: false
    };
  }

  render() {
    const {
      bg,
      src,
      firstName,
      initials: userInitials,
      lastName,
      size,
      ...props
    } = this.props;
    const {
      imgFailedLoading
    } = this.state;
    const imgUnavailable = !src || imgFailedLoading;
    const avatarSize = getSize(size);
    const initials = userInitials || getInitials(firstName, lastName);
    const fontSize = getInitialsFontSize(avatarSize, size);
    const fontWeight = getFontWeight(size);
    const iconSize = getIconSize(avatarSize, size);
    return React.createElement(AvatarContainer, _extends({
      bg: bg,
      width: avatarSize,
      height: avatarSize
    }, props), !imgUnavailable && React.createElement(Image, {
      width: "100%",
      src: src,
      onError: this.handleError,
      alt: "User Avatar"
    }), imgUnavailable && initials && React.createElement(AvatarInitials, {
      height: avatarSize,
      width: avatarSize,
      fontSize: fontSize,
      fontWeight: fontWeight
    }, initials), imgUnavailable && !initials && React.createElement(Flex, {
      justifyContent: "center",
      alignItems: "center",
      size: avatarSize,
      p: 1
    }, this.renderIcon(props, iconSize)));
  }

}

_defineProperty(Avatar, "propTypes", {
  /** Background color of avatar */
  bg: PropTypes.string,

  /** First name of user - initials will be used */
  firstName: PropTypes.string,

  /** Initials to be used in favor of calulating via firstName and lastName  */
  initials: PropTypes.string,

  /** Name of custom icon to render  */
  iconName: PropTypes.string,

  /** Color of customer rendered icon  */
  iconColor: PropTypes.string,

  /** Fill of customer rendered icon  */
  iconFill: PropTypes.string,

  /** Stroke of customer rendered icon  */
  iconStroke: PropTypes.string,

  /** Stroke width of customer rendered icon  */
  iconStrokeWidth: PropTypes.string,

  /** Stroke line cap of customer rendered icon  */
  iconStrokeLinecap: PropTypes.string,

  /** Stroke line join of customer rendered icon  */
  iconStrokeLinejoin: PropTypes.string,

  /** Last name of user - initials will be used */
  lastName: PropTypes.string,

  /** Height and width of the avatar */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['sm', 'md', 'lg'])]),

  /** Src passed to <Image /> */
  src: PropTypes.string
});

_defineProperty(Avatar, "defaultProps", {
  firstName: undefined,
  initials: undefined,
  lastName: undefined,
  iconName: undefined,
  iconFill: undefined,
  iconStroke: undefined,
  iconStrokeWidth: undefined,
  iconStrokeLinecap: undefined,
  iconStrokeLinejoin: undefined,
  iconColor: undefined,
  bg: 'gray.0',
  size: 'md',
  src: ''
});

export default Avatar;